<script lang="ts" setup></script>

<template>
  <div class="my-auto flex flex-col items-center gap-4 py-4 text-center">
    <Icon name="i-lucide-search-x" class="text-surface-900 text-4xl" />
    <div class="text-surface-900 font-semibold">
      Ничего не найдено
    </div>
  </div>
</template>
